export default __webpack_public_path__ + "50c1e394b23de513e4d1a1f344d3178b.png";